import { createClient } from "@connectrpc/connect";
import { ISaveService } from "../../../../abstractions/services/actions/ISaveService";
import { BaseLoginResponse } from "../../../../base/response/BaseLoginResponse";
import { grpcTransportProvider } from "../../../../comun/services/grpc/GrpcTransport";
import { mapConnectError } from "../../../../comun/services/grpc/mapConnectError";
import { LoginService } from "../../../../generated/grpc/login_pb";
import { grpcFincaLoteDatabase } from "../../../terceros/database/GrpcFincaLoteDatabase";
import { LoginByTokenRequest } from "../request/LoginByTokenRequest";
import { mapGrpcLoginResponse } from "./mapGrpcLoginResponse";
import { secureStorage } from "./SecureStorageService";

/** Login por token de sesión persistida (`LoginService.CheckTokenAuthWeb`,
 *  gRPC-Web): refresca el token en `secureStorage` al éxito. Se llama en cada
 *  arranque de la app (`BaseInit._checkToken`), así que es el rpc que más se
 *  ejercita de todo el login. */
export class LoginByTokenGrpcService<TResponse extends BaseLoginResponse>
  implements ISaveService<LoginByTokenRequest, TResponse>
{
  async saveAsync(request: LoginByTokenRequest): Promise<TResponse> {
    const client = createClient(LoginService, grpcTransportProvider.get());

    let grpcResponse;
    try {
      grpcResponse = await client.checkTokenAuthWeb({ token: request.token });
    } catch (error) {
      throw mapConnectError(error);
    }

    // Best-effort: si falla, no debe tirar abajo un checkToken que corre en
    // cada carga de página y por lo demás salió bien.
    grpcFincaLoteDatabase
      .replaceAllAsync(grpcResponse.fincas)
      .catch((error: unknown) =>
        console.error("No se pudo guardar fincas/lotes de gRPC login:", error),
      );

    const response = mapGrpcLoginResponse<TResponse>(grpcResponse);
    await secureStorage.set(response.token);
    return response;
  }
}
